import { ReactNode } from "react";
import React from "react";

class ValidationService {

    country(country: string): boolean {
        return country.length == 2;
    }

    firstname(firstname: string): boolean {
        const pattern = /^.*(?=.{3,18})(?=.*[a-z]).*$/;
        return pattern.test(firstname);
    }

    lastname(lastname: string): boolean {
        const pattern = /^.*(?=.{3,18})(?=.*[a-z]).*$/;
        return pattern.test(lastname);
    }

    email(email: string): boolean {
        const pattern = /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i;
        return pattern.test(email);
    }

    password(password: string): boolean {
        const pattern = /^.*(?=.{6,18})(?=.*\d)(?=.*[a-z]).*$/;
        return pattern.test(password);
    }

    showError(data: any, message: string): ReactNode {
        if (data.valid || !data.touched) {
            return null;
        }
        return (<div className="login_reg_valid_errors">{message}</div>);
    }

    showDbError(errors: any[], key: string): ReactNode {
        if (!errors.hasOwnProperty(key)) {
            return null;
        }
        return (<div className="login_reg_valid_errors">{errors[key][0]}</div>);
    }
}

export default new ValidationService();
